import axios from "axios";
function obterIp() {
  return new Promise((resolve, reject) => {
    return axios.get("https://api.ipify.org?format=json")
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default {
    obterIp,
};